import Modal from '@tpct/mission-core/components/Modal';
import { missionStartSubscriptionRequiredMessage } from '@tpct/mission-core/utils/trialDossierMissionGate';
import { __ } from '../utils/i18n';

export type MissionStartSubscriptionModalProps = {
  isOpen: boolean;
  onClose: () => void;
  subscriptionTierUrl: string;
};

const MissionStartSubscriptionModal = ({
  isOpen,
  onClose,
  subscriptionTierUrl,
}: MissionStartSubscriptionModalProps) => (
  <Modal
    isOpen={isOpen}
    onClose={onClose}
    title={__('Mission VS (vsme)')}
    size="small"
    testId="mission-start-subscription-modal"
  >
    <p>{missionStartSubscriptionRequiredMessage()}</p>
    <div className="cabinet-fiscal-period-modal__actions mt-16">
      <button type="button" className="btn-secondary mr-8" onClick={onClose}>
        {__('Fermer')}
      </button>
      <a href={subscriptionTierUrl} className="btn-primary" rel="noopener noreferrer">
        {__("S'abonner")}
      </a>
    </div>
  </Modal>
);

export default MissionStartSubscriptionModal;
